export default "__VITE_ASSET__7y62Z8IF__"